import React from 'react'
import { useTranslation } from 'react-i18next'
import { ErrorTooltip, Text, type TextProps } from '@pbt/pbt-ui-components'

export interface RequiredFilesNoticeProps extends TextProps {
  hasRequiredErrors?: boolean
}
const RequiredFieldsNotice = ({
  hasRequiredErrors,
  variant = 'lowAccent4',
  ...rest
}: RequiredFilesNoticeProps) => {
  const { t } = useTranslation(['Common', 'Validations'])

  return (
    <ErrorTooltip
      message={t('Validations:REQUIRED_FIELDS')}
      open={hasRequiredErrors}
    >
      <Text variant={variant} {...rest}>
        * {t('Common:REQUIRED_FIELDS')}
      </Text>
    </ErrorTooltip>
  )
}
export default RequiredFieldsNotice
